
import { Component, Prop, Vue } from 'vue-property-decorator'
import FillGridMapAsideTaskList from './FillGridMapAsideTaskList.vue'

@Component({
  components: {
    FillGridMapAsideTaskList
  }
})
export default class FillGridMapAside extends Vue {
  @Prop({ required: true, default: () => [] })
  tasks: any[]

  @Prop({ required: true, default: () => [] })
  idents: string[]

  @Prop({ required: true, default: () => [] })
  identsLabels: string[]

  @Prop({ required: false, default: -1 })
  selectedTaskId: number

  asideCollapsed: boolean = false

  get allTasks () {
    return [
      {
        tasks: this.tasks.filter(task => task.locationType === 'planned'),
        icon: 'fa-clock',
        iconColor: '#495057',
        title: 'Planeadas'
      },
      {
        tasks: this.tasks.filter(task => task.locationType === 'visited'),
        icon: 'fa-check-circle',
        iconColor: '#28A745',
        title: 'Visitadas'
      },
      {
        tasks: this.tasks.filter(task => task.locationType === 'no-location'),
        icon: 'fa-exclamation-circle',
        iconColor: '#858585',
        title: 'Sin Ubicación',
        collapsed: true
      }
    ]
  }

  hideAside () {
    this.asideCollapsed = !this.asideCollapsed
    this.$emit('toggle-aside', this.asideCollapsed)
  }

  selectTask (task: any) {
    this.$emit('select-task', task)
  }
}
